import React, { useEffect, useState } from "react";

const images = ["/images/login/1.jpg", "/images/login/6.jpg", "/images/login/5.jpg", "/images/login/4.jpg"];

const getRandomPair = (arr) => {
  const shuffled = [...arr].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, 2);
};

const BackgroundImages = ({ className = "", style = {} }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [mobileImages, setMobileImages] = useState(getRandomPair(images));

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={`fixed inset-0 w-screen h-screen pointer-events-none overflow-hidden z-0 ${className}`} style={style}>
      {/* DESKTOP */}
      {!isMobile && (
        <>
          <Corner src={images[0]} position="top-left" />
          <Corner src={images[1]} position="top-right" />
          <Corner src={images[2]} position="bottom-left" />
          <Corner src={images[3]} position="bottom-right" />
        </>
      )}

      {/* MOBILE */}
      {isMobile && (
        <>
          <Corner src={mobileImages[0]} position="top-left" full />
          <Corner src={mobileImages[1]} position="bottom-right" full />
        </>
      )}
    </div>
  );
};

const Corner = ({ src, position, full = false }) => {
  const positions = {
    "top-left": "top-0 left-0",
    "top-right": "top-0 right-0",
    "bottom-left": "bottom-0 left-0",
    "bottom-right": "bottom-0 right-0",
  };

  return (
    <div className={`absolute overflow-hidden ${positions[position]} ${full ? "w-screen h-1/2" : "w-1/2 h-1/2"}`}>
      <img src={src} alt="" className="w-full h-full object-cover transition-opacity duration-500" />
    </div>
  );
};

export default BackgroundImages;
